class ListController {
  /* @ngInject */
  constructor($http, $sce, $state, $timeout, $window,
    $scope, moment, urls, Session, SUB_CASE_STATES,
    ENABLE_TA_DATE_CLIENT_IDS, INTERNAL_VENDOR_CLIENT_IDS) {
    this.$http = $http;
    this.$sce = $sce;
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$window = $window;
    this.moment = moment;
    this.VERIFY_APP = urls.VERIFY_APP;
    this.Session = Session;
    this.SUB_CASE_STATES = SUB_CASE_STATES;
    this.ENABLE_TA_DATE_CLIENT_IDS = ENABLE_TA_DATE_CLIENT_IDS;
    this.INTERNAL_VENDOR_CLIENT_IDS = INTERNAL_VENDOR_CLIENT_IDS;
  }

  $onInit() {
    this.searchData = {};
    this.charts = [];
    this.datepickerOptions = {};
    this.c3Charts = {};
    this.clientCategories = [];
    this.clientUsers = [];
    this.c3ChartsCount = 3;
    this.view = 'report';
    this.user = this.Session.read('userinfo') || {};
    this.states = Object.values(this.Session.read('states'));
    this.isVendor = this.user.client.type === 'VENDOR';
    this.isCustomer = this.user.client.type === 'CUSTOMER';
    this.reportStatuses = [
      'Positive', 'Negative', 'Discrepant', 'In Process/Pending', 'Cancelled',
    ];
    this.enableTADate = this.ENABLE_TA_DATE_CLIENT_IDS.includes(this.user.client.id)
      || this.INTERNAL_VENDOR_CLIENT_IDS.includes(this.user.client.id);

    this.caseChecks = [
      {
        check: 'education',
        title: 'Education Check',
      },
      {
        check: 'employmentCheck',
        title: 'Employment Check',
      },
      {
        check: 'uanCheck',
        title: 'UAN Check',
      },
      {
        check: 'cvValidationCheck',
        title: 'CV Validation Check',
      },
      {
        check: 'gapInEmploymentHistoryCheck',
        title: 'Gap In Employment History Check',
      },
      {
        check: 'criminalPoliceCheck',
        title: 'Criminal Police Check',
      },
      {
        check: 'addressCheck',
        title: 'Address Check - Physical',
      },
      {
        check: 'digitalAddressCheck',
        title: 'Address Check - Digital',
      },
      {
        check: 'employmentReferenceCheck',
        title: 'Employment Reference Check',
      },
      {
        check: 'criminalCourtRecordCheck',
        title: 'Criminal Court Record Check',
      },
      {
        check: 'eCourtRecordCheck',
        title: 'Ecourt Record Check',
      },
      {
        check: 'openWebScanCheck',
        title: 'Open Web Scan Check',
      },
      {
        check: 'globalDatabaseCheck',
        title: 'Global Database Check',
      },
      {
        check: 'indianDatabaseCheck',
        title: 'Indian Database Check',
      },
      {
        check: 'creditScoreCheck',
        title: 'Credit Score Check',
      },
      {
        check: 'identity',
        title: 'Identity Check',
      },
    ];
    this.resetSearch();

    if (this.isVendor) this.getClientUsers();

    this.$http.get('/case/category', {
      params: {
        allocatedTemplates: true,
      },
    })
      .then(({ data = [] }) => {
        this.clientCategories = data;

        this.categories = this.isCustomer ? data[0].ClientCategories : [];
      });

    this.$scope.bgvTrackerData = {};
    this.gridConfig();
  }

  resetSearch() {
    this.searchData = {
      clientIds: [],
      categoryIds: [],
      reportStatuses: [],
      currentStates: [],
      initDateStart: null,
      initDateEnd: null,
      finalReportSubmittedDateStart: null,
      finalReportSubmittedDateEnd: null,
    };
  }

  getClientUsers() {
    this.$http.get('/clientVendor/clientUsers')
      .then(({ data = [] }) => (this.clientUsers = data));
  }

  getCategories() {
    this.categories = this.searchData.clientIds
      .reduce((acc, cl) => acc.concat(
        this.clientCategories.find(clCat => clCat.id === cl).ClientCategories
      ), []);
  }

  getBgvTrackerData(refresh) {
    this.showSpinner = true;
    this.$http.post('/report/bgv_tracker', this.searchData)
      .then((response) => {
        const { data: { tracker } } = response;
        this.$scope.bgvTrackerData = tracker;
        const statusCountMap = {};
        const bgvStatusCountMap = {};
        const categoryAvgTatMap = {};

        tracker.forEach((caseData) => {
          statusCountMap[caseData.current_status] =
            (statusCountMap[caseData.current_status] || 0) + 1;
          bgvStatusCountMap[caseData.bgv_report_status] =
            (bgvStatusCountMap[caseData.bgv_report_status] || 0) + 1;

          if (caseData.tat) {
            if (!categoryAvgTatMap[caseData.category_name]) {
              categoryAvgTatMap[caseData.category_name] = {
                cnt: 0,
                totalTat: 0,
              };
            }

            categoryAvgTatMap[caseData.category_name] = {
              cnt: categoryAvgTatMap[caseData.category_name].cnt + 1,
              totalTat: categoryAvgTatMap[caseData.category_name].totalTat + (caseData.tat || 0),
            };
          }
        });

        this.charts = [{
          type: 'donut',
          title: 'Status',
          data: Object.entries(statusCountMap).map(([key, val]) => ([key, val])),
        }, {
          type: 'donut',
          title: 'BGV Status',
          data: Object.entries(bgvStatusCountMap).map(([key, val]) => ([key, val])),
        }, {
          type: 'donut',
          title: 'Avg TAT',
          data: Object.entries(categoryAvgTatMap)
            .map(([key, val]) => ([key, Math.round(val.totalTat / val.cnt)]), {}),
        }];

        this.$timeout(() => {
          this.renderChart(refresh);
        });
      })
      .catch(() => {
        this.$scope.bgvTrackerData = [];
        this.charts = [];
      })
      .finally(() => (this.showSpinner = false));
  }

  trustSrc(src) {
    return this.$sce.trustAsResourceUrl(src);
  }

  setSpinner(bool) {
    this.$scope.$apply(() => (this.showSpinner = bool));
  }

  renderChart(refresh) {
    this.charts.forEach((chart, i) => {
      if (!chart.data.length) {
        Object.assign(chart, {
          data: [['No Results', 100]],
        });
      }

      if (!refresh) {
        this.c3Charts[i] = this.$window.c3.generate({
          bindto: `#chart${i}`,
          data: {
            columns: chart.data,
            type: 'donut',
          },
          donut: {
            label: {
              format: (value, ratio, id) => (id === 'No Results' ? '' : value),
            },
            title: chart.title,
          },
          tooltip: {
            format: {
              value(value, ratio) { return `${value} (${Math.round(ratio * 100)}%)`; },
            },
          },
          // legend: {
          //   position: 'right',
          // },
        });
      } else {
        this.c3Charts[i].load({
          columns: chart.data,
          unload: true,
        });
      }
    });
  }

  htmltoText(html) {
    let text = html;
    text = text.replace(/\n/gi, '');
    text = text.replace(/<style([\s\S]*?)<\/style>/gi, '');
    text = text.replace(/<script([\s\S]*?)<\/script>/gi, '');
    text = text.replace(/<a.*?href="(.*?)[?"].*?>(.*?)<\/a.*?>/gi, ' $2 $1 ');
    text = text.replace(/<\/div>/gi, '\n\n');
    text = text.replace(/<\/li>/gi, '\n');
    text = text.replace(/<li.*?>/gi, '  *  ');
    text = text.replace(/<\/ul>/gi, '\n\n');
    text = text.replace(/<\/p>/gi, '\n\n');
    text = text.replace(/<br\s*[/]?>/gi, '\n');
    text = text.replace(/<[^>]+>/gi, '');
    text = text.replace(/^\s*/gim, '');
    text = text.replace(/ ,/gi, ',');
    text = text.replace(/ +/gi, ' ');
    text = text.replace(/\n+/gi, '\n\n');
    text = text.replace(/&#160;|&#8217|&#65279;/g, ' ');
    return text;
  }

  gridConfig() {
    this.gridOptions = {
      data: 'bgvTrackerData',
      enableSorting: true,
      enableFiltering: true,
      multiSelect: true,
      enableSelectAll: true,
      enableColumnResizing: true,
      paginationPageSize: 50,
      paginationPageSizes: [50, 100, 200],
      enableGridMenu: true,
      enableRowHeaderSelection: true,
      // saveFocus: false,
      // saveGroupingExpandedStates: true,
      exporterMenuExcel: false,
      exporterMenuPdf: false,
      exporterCsvFilename: `bgv_tracker_${this.moment().format('YYYY_MM_DD')}.csv`,
      // exporterExcelFilename: 'bgv_report.xlsx',
      // exporterExcelSheetName: 'Sheet1',
      // rowHeight: 1122,
      columnVirtualizationThreshold: 100,
      columnDefs: [
        {
          name: 'full_name',
          displayName: 'Candidate Name',
          cellTooltip: true,
          enableFiltering: true,
          cellTemplate: [
            '<div class="ui-grid-cell-contents"> ',
            `<a target="_blank" href="${this.VERIFY_APP}/main/cases/{{ row.entity.case_id }}/view"`,
            'title="{{ COL_FIELD }}">{{ COL_FIELD }}</a></div>',
          ].join(' '),
          type: 'string',
          width: 200,
          // pinnedLeft: true,
        },
        ...(this.isVendor ? [{
          name: 'client_name',
          displayName: 'Client Name',
          cellTooltip: true,
          enableFiltering: false,
          type: 'text',
          width: 150,
        }] : []),
        {
          name: 'email',
          displayName: 'Email ID',
          cellTooltip: true,
          enableFiltering: true,
          type: 'string',
          width: 200,
        },
        {
          name: 'unique_id',
          displayName: 'Unique ID',
          cellTooltip: true,
          enableFiltering: true,
          type: 'number',
          width: 100,
          cellClass: 'text-center',
        },
        {
          name: 'employee_code',
          displayName: 'Employee Code',
          cellTooltip: true,
          enableFiltering: true,
          type: 'string',
          width: 150,
          cellClass: 'text-center',
        },
        ...(this.enableTADate ? [{
          name: 'case_ta_date',
          displayName: 'TA Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        }, {
          name: 'case_doj_date',
          displayName: 'Date of Joining',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        }, {
          name: 'case_joining_status',
          displayName: 'Joining Status',
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 150,
        }] : []),
        {
          name: 'bgv_report_status',
          displayName: 'B G V Report Status',
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 150,
        },
        {
          name: 'dob',
          displayName: 'Date Of Birth',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'category_name',
          displayName: 'Category Name',
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 150,
        },
        {
          name: 'current_status',
          displayName: 'Current Status',
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 200,
        },
        {
          name: 'case_raised_on',
          displayName: 'Case Raised Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'first_doc_upload_date',
          displayName: '1st Detail/Document Upload Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'overrided_init_date',
          displayName: 'Date of Initiation',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'overrided_final_init_date',
          displayName: 'Final Date of Initiation',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'interim_report_date',
          displayName: 'Interim Report Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'final_report_submitted_date',
          displayName: 'Final Report Submitted Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'revised_final_report_submitted_date',
          displayName: 'Revised Final Report Submitted Date',
          cellTooltip: true,
          enableFiltering: false,
          type: 'date',
          cellFilter: 'date: \'dd-MMM-yyyy\'',
          filterCellFiltered: true,
          width: 150,
        },
        {
          name: 'tat',
          displayName: 'TAT',
          cellTooltip: true,
          enableFiltering: false,
          type: 'number',
          width: 150,
        },
        {
          name: 'latest_comment',
          displayName: 'Latest Comment',
          cellTemplate: [
            '<div class="ui-grid-cell-contents">',
            '<p ng-bind-html="row.entity.latest_comment"',
            'title="{{row.entity.latest_comment | removeHtmlTag}}"></p></div>',
          ].join(' '),
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 250,
        },
        ...this.caseChecks.map((checkJson) => ({
          name: checkJson.check,
          displayName: checkJson.title,
          cellTemplate: [
            '<div class="ui-grid-cell-contents">',
            `<p ng-bind-html="row.entity.checksMeta.${checkJson.check}.status"`,
            `title="{{row.entity.checksMeta.${checkJson.check}.comment | removeHtmlTag}}">`,
            '</p></div>',
          ].join(' '),
          cellTooltip: true,
          enableFiltering: false,
          type: 'string',
          width: 150,
        })),
      ],
      exporterFieldCallback: (grid, row, col, value) => {
        if (col.colDef.type === 'date') {
          return value && this.moment(value).format('DD-MMM-YYYY');
        } else if (['latest_comment'].includes(col.field)) {
          return (value ? this.htmltoText(value) : '');
        } else if (this.caseChecks.map(check => check.check).includes(col.field)) {
          let checkStatus = row.entity.checksMeta[col.field].status;
          let checkComment = row.entity.checksMeta[col.field].comment;

          checkStatus = checkStatus === '-' ? '' : checkStatus;
          checkComment = checkComment === '-' ? '' : checkComment;

          if (checkStatus && checkComment) {
            return `${checkStatus} - ${this.htmltoText(checkComment)}`;
          }

          return checkStatus || checkComment || '-';
        }
        return value;
      },
      onRegisterApi: (registeredApi) => {
        this.gridApi = registeredApi;
        this.$scope.gridApi = registeredApi;
        this.restoreState();
        this.getBgvTrackerData();
      },
    };
  }

  saveState() {
    this.$scope.state = this.$scope.gridApi.saveState.save();
    this.$scope.state.columns.forEach(col => Object.assign(col, { filters: [{}] }));
    this.Session.create('report-list-bgv-tracker.state', this.$scope.state);
  }

  restoreState() {
    this.$timeout(() => {
      const state = this.$scope.state || this.Session.read('report-list-bgv-tracker.state');
      if (state) this.$scope.gridApi.saveState.restore(this.$scope, state);
    });
  }

  clearState() {
    this.$timeout(() => {
      this.Session.remove('report-list-bgv-tracker.state');
      this.$window.location.reload();
    });
  }
}

export default ListController;



// WEBPACK FOOTER //
// ./client/app/reports/bgvTracker/bgvTracker.controller.js